const config = {
    loaderSalaryConfirm: {
        'bigData-btn-search': '仓储资源管理,装卸人员工资确认,,查询',
        'bigData-btn-export': '仓储资源管理,装卸人员工资确认,,导出',
    },
}
export default config
